import { createContext, useContext } from "react";

export const PlacesContext = createContext(null);

export function usePlacesContext() {
  return useContext(PlacesContext);
}
